import {
  ClearButtons,
  FormatButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  QuoteButtons,
  RichTextInput,
  RichTextInputToolbar,
} from "ra-input-rich-text";
import * as React from "react";
import {
  ArrayInput,
  Create,
  CreateProps,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";
import ImageCropInput from "../../creatorsShared/imageCrop/ImageCropInput";

const BannersCreate = (props: CreateProps) => {
  const [locale] = useLocaleState();

  return (
    <Create {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <ImageCropInput
          slot="banner"
          fullWidth
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          label={false}
          source="bannerImage"
        />
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="bannerTitle" label="banners.title" />

          <TextInput
            fullWidth
            source="bannerSubtitle"
            label="banners.subtitle"
          />

          <ArrayInput source="bannerSlogans" label="banners.slogans">
            <SimpleFormIterator fullWidth>
              <RichTextInput
                toolbar={
                  <RichTextInputToolbar>
                    <LevelSelect />
                    <FormatButtons />
                    <ListButtons />
                    <LinkButtons />
                    <QuoteButtons />
                    <ClearButtons />
                  </RichTextInputToolbar>
                }
                fullWidth
                source="slogan"
                label="banners.slogan"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SimpleForm>
    </Create>
  );
};

export default BannersCreate;
